import { Shortcut } from './types';

export const SHORTCUTS: Shortcut[] = [
  { label: 'Today', days: 0 },
  { label: 'Last 2 Days', days: 1 },
  { label: 'Week', days: 7 },
  { label: 'Month', days: 30 },
  { label: 'Year', days: 365 },
];

// Generate Hours: ["00", "01", ..., "23"]
export const hoursArray: string[] = Array.from({ length: 24 }, (_, i) =>
  i.toString().padStart(2, '0'),
);

// Generate Minutes: ["00", "01", ..., "59"]
export const minutesArray: string[] = Array.from({ length: 60 }, (_, i) =>
  i.toString().padStart(2, '0'),
);
